import _t from "@core/i18n"
import type { TableAriaLabels } from "@onestore/hel/dist/components/molecules/TableMol"

export const getTableAriaLabels = (): TableAriaLabels => ({
  tableLabel: _t("tableAriaLabels.table"),
  rowGroupLabel: _t("tableAriaLabels.rowGroup"),
  rowLabel: _t("tableAriaLabels.row"),
  columnHeaderLabel: _t("tableAriaLabels.columnHeader"),
  cellLabel: _t("tableAriaLabels.cell"),
})
